import { render, staticRenderFns } from "./PreCadastro.vue?vue&type=template&id=3cdbf4ce&scoped=true"
import script from "./PreCadastro.vue?vue&type=script&lang=ts"
export * from "./PreCadastro.vue?vue&type=script&lang=ts"
import style0 from "./PreCadastro.vue?vue&type=style&index=0&id=3cdbf4ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbf4ce",
  null
  
)

export default component.exports